<template>
  <div id="app">
    <router-view   v-if="routerAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
         return {
        routerAlive:true
       }
   },
   provide(){    //在父组件中创建属性
           return {
                routerRefresh: this.routerRefresh
            }
         },
     methods:{
    
        routerRefresh(){         
        this.routerAlive = false;
        this.$nextTick(()=>{
            this.routerAlive = true;
        });
         }
     },

     
}


</script>

<style >
@import "./assets/style/index";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif,;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  width: 100%;
  height: 100%;
  
}
.el-tooltip__popper.is-light{ 
  border: 1px solid #CCCCCC  !important;
  background: #FEFDF8 !important;
  max-width: 300px;
  min-height: 32px;
  color:#333333;
  border-radius: 4px;
  font-size: 14px;
}
.el-popover{
 background:#FEFDF8 !important;
 border: 1px solid #CCCCCC !important;
 min-height: 32px;
 border-radius: 4px;
 max-width: 300px;
 color:#333333;
 font-size: 14px;
}
.el-notification {
  height: 179px !important;
  width: 427px !important;
  border: 0px;
  background-color: rgb(255 255 255 / 0);
  bottom:10px!important;
  right: 10px !important;
  border-radius: 12px!important;
  }
.el-notification__content p {
  margin: -19px 0px 0px -26px!important;
}
.el-notification__closeBtn {
    position: absolute;
    top: 7px;
    right: 10px;
    cursor: pointer;
    color: #909399;
    font-size: 32px;
    opacity: 0;
}
.in-active-path{
   color: #37c1b5 !important;
}

.is-active{ 
  color: #37c1b5!important
}
 .el-loading-spinner i {
    color: #37c1b5;
}
 .el-loading-spinner .el-loading-text {
    color: #37c1b5;
}

@media screen and (max-width: 1440px) {
   /deep/ .phone-view-wrap{
    zoom: 1.177;
 }
  body {
      zoom: 0.85;
  }

}
</style>




// WEBPACK FOOTER //
// src/App.vue